import { call, put, takeLatest } from 'redux-saga/effects'
import { O_FETCH_SEARCH, O_FETCH_SUGGESTIONS } from './constants'
import { fetchOsearch, fetchAutoSuggest } from './services'
import { fetchSearch, fetchSuggestions } from './actions'

function* fetchSuggestionsWorker(action) {
  const { query } = action ?? {}
  const data = yield call(fetchAutoSuggest, query)
  yield put(fetchSuggestions.success(data))
}

function* fetchSearchWorker(action) {
  const { query, filters, pageNumber, pageLength } = action ?? {}
  const data = yield call(fetchOsearch, query, filters, pageNumber, pageLength)
  yield put(fetchSearch.success(data))
}

export default function* watcher() {
  yield takeLatest(O_FETCH_SEARCH.REQUEST, fetchSearchWorker)
  yield takeLatest(O_FETCH_SUGGESTIONS.REQUEST, fetchSuggestionsWorker)
}
